export const pageUrlGenerator = (page) =>
  `${window.location.protocol}//${window.location.host}${page}`;

export const AnvioGamesData = {
  AnvioGames: {
    slide1: {
      Zhandu: {
        redirectUrl: "/casino/anvioanvio-zhandu",
        code: "",
        casino: "anvio",
        imgUrl: "./images/anvio-games/Zandu.jpg",
        homeUrl: pageUrlGenerator("/"),
        name: "Zhandu",
        providerName: "Anvio",
      },
      Teenpatti: {
        redirectUrl: "/casino/anvioanvio-teenpatti",
        code: "",
        casino: "Anvio",
        imgUrl: "./images/anvio-games/Teenpatti.jpg",
        homeUrl: pageUrlGenerator("/Slots"),
        name: "Teenpatti",
        providerName: "Anvio",
      },
      DragonTiger: {
        redirectUrl: "/casino/anvioanvio-dragon-tiger",
        code: "",
        casino: "Anvio",
        imgUrl: "./images/anvio-games/DragonTiger.jpg",
        homeUrl: pageUrlGenerator("/Slots"),
        name: "Dragon Tiger",
        providerName: "Anvio",
      },
      Dana: {
        redirectUrl: "/casino/anvioanvio-dana",
        code: "",
        casino: "Anvio",
        imgUrl: "./images/anvio-games/Dana.jpg",
        homeUrl: pageUrlGenerator("/Slots"),
        name: "Dana",
        providerName: "Anvio",
      },
    },
    name: "Anvio Games",
    key: "anvioGames",
  },
};
